import React, { Component } from 'react';
import Dashboard from '../dashboard/Dashboard';


export default class ProfilePage extends Component {
    render() {
        return (
                <Dashboard />
        )
    }
}
